import { render } from "./QwoachDialogLayout.vue?vue&type=template&id=ecbcc35a"
import script from "./QwoachDialogLayout.vue?vue&type=script&lang=js"
export * from "./QwoachDialogLayout.vue?vue&type=script&lang=js"

import "./QwoachDialogLayout.vue?vue&type=style&index=0&id=ecbcc35a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__